module.exports = __webpack_public_path__ + "img/cloth_g3_shirt-01.afce777a.svg";